import { PartialGridItemProduct } from "../../../ui/organisms/Product/ProductGridItem/types"
import { fetchAlgoliaBoughtTogetherItems } from "../queries/boughtTogegher"
import { fetchAlgoliaCarouselItems } from "../queries/carousel"
import { fetchAlgoliaRelatedItems } from "../queries/related"
import {
  AlgoliaDynamicCarouselDefinition,
  AlgoliaDynamicCarouselItem,
} from "../types/carousel"

const fetchAlgoliaDynamicCarouselItem = async (
  item: AlgoliaDynamicCarouselItem
): Promise<PartialGridItemProduct[]> => {
  switch (item.type) {
    case "boughtTogether":
      return fetchAlgoliaBoughtTogetherItems({
        excludeProductIds: item.exclude ?? [],
        sourceEan: item.sourceVariantId as string,
        brandCodes: item.brands,
        maxItems: item.maxResults,
      })
    case "recommendations":
      return fetchAlgoliaRelatedItems({
        excludeProductIds: item.exclude ?? [],
        sourceEan: item.sourceVariantId as string,
        brandCodes: item.brands,
        maxItems: item.maxResults,
      })
    case "search":
      return fetchAlgoliaCarouselItems({
        item,
      })
  }
}

export const fetchAlgoliaDynamicCarousel = async (
  definition: AlgoliaDynamicCarouselDefinition
): Promise<PartialGridItemProduct[]> => {
  const results: PartialGridItemProduct[] = []
  for (const item of definition.items) {
    const placesLeft = definition.maxProducts - results.length
    if (placesLeft <= 0) {
      break
    }
    const itemProducts = await fetchAlgoliaDynamicCarouselItem({
      ...item,
      exclude: [
        ...(item.exclude ?? []),
        ...results.map((x) => x.defaultVariant.info.productId),
      ],
      maxResults: Math.min(placesLeft, item.maxResults),
    })
    results.push(...itemProducts)
  }
  return results
}
